import Vue from "vue";
import Vuetify from "vuetify/lib";
import "@/scss/vuetify/overrides.scss";
Vue.use(Vuetify);

// Paleta Mundo Bandera: primario azul-gris #2d465e (riel), acento verde #018651
const theme = {
  primary: "#2d465e",   // azul-gris de marca
  secondary: "#018651", // verde de marca (acentos)
  accent: "#018651",
  info: "#2d465e",
  success: "#018651",
  warning: "#f59e0b",
  error: "#e53935",
  default: "#2d465e",
};

export default new Vuetify({
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
    dark: false, // If you want to set dark theme then dark:true else set to false
  },
  rtl: false, // If you want to set rtl theme then rtl:true else set to false
});
